import React, { useContext } from 'react';
import { ColumnProps } from 'antd/lib/table';
import dayjs from 'dayjs';

import OsPatchContext from '@totem/components/devices/os-patches/osPatchContext';
import { OSPatch } from '@totem/components/devices/os-patches/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { formatDateTimeDisplay } from '@totem/utilities/timeUtilities';

const OSPatchTable = () => {
  const { data, loading } = useContext(OsPatchContext);

  const getData = () => {
    if (typeof data !== 'undefined' && data !== null) {
      return data;
    }
    return [];
  };

  const columns: ColumnProps<OSPatch>[] = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (compA, compB) =>
        compA.name === compB.name ? 0 : compA.name > compB.name ? 1 : -1,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      sorter: (compA, compB) =>
        compA.type === compB.type ? 0 : compA.type > compB.type ? 1 : -1,
    },
    {
      title: 'Severity',
      dataIndex: 'severity',
      key: 'severity',
      sorter: (compA, compB) =>
        compA.severity === compB.severity
          ? 0
          : compA.severity > compB.severity
            ? 1
            : -1,
    },
    {
      title: 'KB Number',
      dataIndex: 'kbNumber',
      key: 'kbNumber',
      sorter: (compA, compB) =>
        compA.kbNumber === compB.kbNumber
          ? 0
          : compA.kbNumber > compB.kbNumber
            ? 1
            : -1,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: (compA, compB) =>
        compA.status === compB.status
          ? 0
          : compA.status > compB.status
            ? 1
            : -1,
    },
    {
      title: 'Installed At',
      dataIndex: 'installedAt',
      key: 'installedAt',
      defaultSortOrder: 'descend',
      render: (_, record: OSPatch) =>
        formatDateTimeDisplay(dayjs.unix(record.installedAt).toISOString()),
      sorter: (compA, compB) =>
        compA.installedAt === compB.installedAt
          ? 0
          : compA.installedAt > compB.installedAt
            ? 1
            : -1,
    },
  ];

  return (
    <IBTable
      showSorterTooltip
      columns={columns}
      dataSource={getData()}
      loading={loading}
      rowKey={(record) => record.id}
    />
  );
};

export default OSPatchTable;
